<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="faq">
      <Title jpn="FAQ" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('サイトについて')"
        >
          <div class="text-container">
            <!-- Xmarket関連 非表示
            <div class="block">
              <span class="text question" :class="{ active: isOpen.site[0] }" @click="toggleQuestion('site',0)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('Xmarketとはなんですか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.site[0] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.site[0]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">
                      <a class="url" :href="xmarketLink" target="_blank">
                        <div class="text pre-line">{{ t('ガチャで当たった景品を出品できたり、欲しいカードを購入できます。\n詳細はこちらをクリックしてください。') }}</div>
                      </a>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            -->
            <div class="block">
              <span class="text question" :class="{ active: isOpen.site[1] }" @click="toggleQuestion('site',1)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('shopとはなんですか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.site[1] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.site[1]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">
                      <div class="text">{{ t('日本のさまざまな法人さまの商品をガチャで購入することができるページです。') }}</div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="block">
              <span class="text question" :class="{ active: isOpen.site[2] }" @click="toggleQuestion('site',2)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('友達を紹介してコインを貰いたいけど、どうすればいいですか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.site[2] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.site[2]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">
                      <a class="url" :href="referralBonusLink" target="_blank">
                        <div class="text pre-line">{{ t('SMS認証完了後、マイページに表示される「紹介コード」をご友人に会員登録時に入力してもらってください。\nそのご友人が「SMS認証」と「コイン購入」で、あなたとご友人の双方にコインが入ります。\n※双方が貰えるコイン数はこちらからご確認ください。') }}</div>
                      </a>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="block">
              <span class="text question" :class="{ active: isOpen.site[3] }" @click="toggleQuestion('site',3)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('会員ランクを翌月も維持することはできますか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.site[3] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.site[3]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">
                      <a class="url" :href="rankBonusLink" target="_blank">
                        <div class="text pre-line">{{ t('シルバー会員以上の方はマイページの専用ボタンでコインを消費することにより、1つ下のランクから翌月はスタートすることが可能です。\n※ブロンズランクは3ヶ月間ブロンズが維持されます。\n詳細はこちらからご確認ください。') }}</div>
                      </a>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="block">
              <span class="text question" :class="{ active: isOpen.site[4] }" @click="toggleQuestion('site',4)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('私の会社の商材もガチャで販売できますか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.site[4] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.site[4]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">
                      <a class="url" href="https://xeroplace.jp/gtchax-online" target="_blank">
                        <div class="text">{{ t('ご検討ありがとうございます。まずはこちらよりお問合せをお願いいたします。') }}</div>
                      </a>
                      </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="block">
              <span class="text question" :class="{ active: isOpen.site[5] }" @click="toggleQuestion('site',5)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('問い合わせへの返信はどのくらいの時間で返ってきますか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.site[5] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.site[5]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">

                      <div class="text">{{ t('原則2営業日以内にお返事いたします。') }}</div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="block">
              <span class="text question" :class="{ active: isOpen.site[6] }" @click="toggleQuestion('site',6)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('動画を見たのにコインが貰えなかった。なぜでしょうか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.site[6] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.site[6]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">

                      <div class="text pre-line">{{ t('動画を離脱することなく、最後までご視聴ください。\nそれでも反映されない場合は恐れ入りますがお問い合わせくださいませ。') }}</div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('発送について')"
        >
          <div class="text-container">
            <div class="block">
              <span class="text question" :class="{ active: isOpen.shipping[0] }" @click="toggleQuestion('shipping',0)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('発送はいつですか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.shipping[0] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.shipping[0]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">
                      <div class="text">{{ t('発送は、毎月5日・10日・15日・20日・25日・月末におこなわせていただきます。') }}</div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="block">
              <span class="text question" :class="{ active: isOpen.shipping[1] }" @click="toggleQuestion('shipping',1)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('梱包は丁寧ですか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.shipping[1] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.shipping[1]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">
                      <div class="text">{{ t('配送過程で傷が付かないよう丁寧に梱包することを心掛けます。\nもし、ご希望やご要望等がございましたらご遠慮なく本サイトのチャットよりお申し付けくださいませ。') }}</div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="block">
              <span class="text question" :class="{ active: isOpen.shipping[2] }" @click="toggleQuestion('shipping',2)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('配送業者はどこですか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.shipping[2] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.shipping[2]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">
                      <div class="text">{{ t('ヤマト運輸にて発送いたします。') }}</div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="block">
              <span class="text question" :class="{ active: isOpen.shipping[3] }" @click="toggleQuestion('shipping',3)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('送料はかかりますか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.shipping[3] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.shipping[3]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">
                      <div class="text">{{ t('送料は弊社が全額負担で元払いで発送いたします。') }}</div>
                    </div>
                  </div>
              </div>
              </transition>
            </div>
            <div class="block">
              <span class="text question" :class="{ active: isOpen.shipping[4] }" @click="toggleQuestion('shipping',4)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('追跡番号はどこでわかりますか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.shipping[4] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.shipping[4]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">
                      <a class="url" href="https://gtchaxonline.com/shipped-detail" target="_blank">
                        <div class="text">{{ t('こちらよりご確認をお願いいたします。') }}</div>
                      </a>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="block">
              <span class="text question" :class="{ active: isOpen.shipping[5] }" @click="toggleQuestion('shipping',5)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('発送通知からどのくらいで追跡番号がインターネットで確認できますか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.shipping[5] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.shipping[5]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">
                      <div class="text">{{ t('発送通知日と実際の発送日は配送業務の関係上異なってしまうことがございます。\nそのため、毎月5日・10日・15日・20日・25日・月末の夕方以降にご確認をお願いいたします。') }}</div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="block">
              <span class="text question" :class="{ active: isOpen.shipping[6] }" @click="toggleQuestion('shipping',6)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('住所変更はどこからできますか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.shipping[6] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.shipping[6]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">
                      <a class="url" :href="addressChangeLink" target="_blank">
                        <div class="text">{{ t('こちらからお問い合わせください。弊社側で変更いたします。') }}</div>
                      </a>
                      </div>
                  </div>
                </div>
              </transition>
            </div>
            <!-- Xmarket関連 非表示
            <div class="block">
              <span class="text question" :class="{ active: isOpen.shipping[7] }" @click="toggleQuestion('shipping',7)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('X marketで買った商品は何日くらいで届きますか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.shipping[7] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.shipping[7]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">
                      <div class="text">{{ t('発送は、毎月5日・10日・15日・20日・25日・月末におこなわせていただきます。') }}</div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            -->
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('商品について')"
        >
          <div class="text-container">
            <div class="block">
              <span class="text question" :class="{ active: isOpen.product[0] }" @click="toggleQuestion('product',0)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('カードの状態は綺麗ですか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.product[0] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.product[0]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">
                      <a class="url" :href="notesLink" target="_blank">
                        <div class="text pre-line">{{ t('一律「中古品(二次流通品)・傷あり品」というご認識でお願いいたします。\nご留意事項等はこちらよりご確認をお願いいたします。') }}</div>
                      </a>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="block">
              <span class="text question" :class="{ active: isOpen.product[1] }" @click="toggleQuestion('product',1)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('違う商品が届いた。どうすればいいですか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.product[1] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.product[1]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">
                      <a class="url" :href="contactLink" target="_blank">
                        <div class="text pre-line">{{ t('弊社で保管しているデータと確認させていただきます。\n恐れ入りますが、こちらよりお問い合わせくださいませ。') }}</div>
                      </a>
                      </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('shopについて')"
        >
          <div class="text-container">
            <div class="block">
              <span class="text question" :class="{ active: isOpen.gacha[0] }" @click="toggleQuestion('gacha',0)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('私たちの会社の商品を販売して欲しい。どうしたらいいですか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.gacha[0] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.gacha[0]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">
                      <a class="url" href="https://xeroplace.jp/gtchax-online" target="_blank">
                        <div class="text">{{ t('ご検討ありがとうございます。まずはこちらよりお問合せをお願いいたします。') }}</div>
                      </a>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </ShadowBoxTitleDescription>
        <!-- Xmarket関連 非表示
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('X marketについて')"
        >
          <div class="text-container">
            <div class="block">
              <span class="text question" :class="{ active: isOpen.Xmarket[0] }" @click="toggleQuestion('Xmarket',0)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('X marketに出品できないのはなぜですか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.Xmarket[0] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.Xmarket[0]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">
                      <div class="text pre-line">{{ t('出品は、ブロンズ会員以上の方のみとなります。\nまた、当該ガチャの1回あたりの販売コイン数を上回る還元コイン数以上のお品物しか出品できません。') }}</div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="block">
              <span class="text question" :class="{ active: isOpen.Xmarket[1] }" @click="toggleQuestion('Xmarket',1)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('X marketで買った商品は何日くらいで届きますか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.Xmarket[1] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.Xmarket[1]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">
                      <div class="text">{{ t('発送は、毎月5日・10日・15日・20日・25日・月末におこなわせていただきます。') }}</div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </ShadowBoxTitleDescription>
        -->
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('アカウントについて')"
        >
          <div class="text-container">
            <div class="block">
              <span class="text question" :class="{ active: isOpen.account[0] }" @click="toggleQuestion('account',0)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('パスワードを忘れた。どうすればいいですか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.account[0] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.account[0]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">
                      <div class="text pre-line">{{ t('ログイン画面よりパスワード再発行をクリックして、仮パスワードでログインしてください。\nその後、マイページよりパスワードをご変更ください。') }}</div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="block">
              <span class="text question" :class="{ active: isOpen.account[1] }" @click="toggleQuestion('account',1)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('退会したい場合はどうすればいいですか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.account[1] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.account[1]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">
                      <a class="url" :href="withdrawalLink" target="_blank">
                        <div class="text">{{ t('恐れ入りますが、こちらよりその旨のご連絡をお願いいたします。') }}</div>
                      </a>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="block">
              <span class="text question" :class="{ active: isOpen.account[2] }" @click="toggleQuestion('account',2)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('1人で複数のアカウントを所有することは可能ですか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.account[2] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.account[2]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">

                      <div class="text pre-line">{{ t('複数アカウントの所持は禁止しております。\n発覚した際は、告知なくアカウント制限の対象となりますので、ご留意くださいませ。') }}</div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="block">
              <span class="text question" :class="{ active: isOpen.account[3] }" @click="toggleQuestion('account',3)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('1アカウントを複数台の端末を利用することは可能ですか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.account[3] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.account[3]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">
                      <div class="text">{{ t('可能です。\n※1台で複数アカウントの利用はアカウント制限の対象にもなり得ますためお控えくださいませ。') }}</div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('郵送買取について')"
        >
          <div class="text-container">
            <div class="block">
              <span class="text question" :class="{ active: isOpen.selling[0] }" @click="toggleQuestion('selling',0)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('何日くらいで査定結果がでますか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.selling[0] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.selling[0]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">

                      <div class="text">{{ t('弊社に到着後、原則2営業日には査定結果をお送りいたします。') }}</div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="block">
              <span class="text question" :class="{ active: isOpen.selling[1] }" @click="toggleQuestion('selling',1)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('いつ入金されますか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.selling[1] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.selling[1]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">
                      <div class="text">
                        {{ t('査定結果へご同意から2営業日以内にお振込いたします。') }}
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="block">
              <span class="text question" :class="{ active: isOpen.selling[2] }" @click="toggleQuestion('selling',2)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('返却は可能ですか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.selling[2] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.selling[2]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">
                      <div class="text pre-line">{{ t('可能です。1枚からでもご返送を承ります。\n着払いにてご返送をさせていただきます。') }}</div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="block">
              <span class="text question" :class="{ active: isOpen.selling[3] }" @click="toggleQuestion('selling',3)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('買取表に載っていないカードの買取は可能ですか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.selling[3] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.selling[3]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">
                      <a class="url" href="https://gtchax0218.zendesk.com/hc/ja/articles/4679247602078-%E9%83%B5%E9%80%81%E8%B2%B7%E5%8F%96%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6" target="_blank">
                        <div class="text pre-line">{{ t('買取表に記載のカードのみとなります。\n予めご容赦くださいませ。') }}</div>
                      </a>
                      </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('コインについて')"
        >
          <div class="text-container">
            <div class="block">
              <span class="text question" :class="{ active: isOpen.coin[0] }" @click="toggleQuestion('coin',0)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('有効期限はありますか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.coin[0] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.coin[0]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">

                      <div class="text">{{ t('はい。取得日より6ヶ月となります。') }}</div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="block">
              <span class="text question" :class="{ active: isOpen.coin[1] }" @click="toggleQuestion('coin',1)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('換金できますか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.coin[1] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.coin[1]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">

                      <div class="text">{{ t('現金への換金はできません。') }}</div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('キャンセル・返品・返金について')"
        >
          <div class="text-container">
            <div class="block">
              <span class="text question" :class="{ active: isOpen.cancel[0] }" @click="toggleQuestion('cancel',0)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('カードの画像と商品名が違うカードが当たった。どっちが正しいですか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.cancel[0] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.cancel[0]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">

                      <div class="text">{{ t('「商品名」の方が優先されます。ご心配をおかけしてしまい、大変申し訳ございません。') }}</div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="block">
              <span class="text question" :class="{ active: isOpen.cancel[1] }" @click="toggleQuestion('cancel',1)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('発送を希望している商品を誤ってコインに還元してしまった。変更できますか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.cancel[1] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.cancel[1]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">
                      <div class="text">{{ t('一度ご決定いただいたものは変更いたしかねます。予めご容赦くださいませ。') }}</div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="block">
              <span class="text question" :class="{ active: isOpen.cancel[2] }" @click="toggleQuestion('cancel',2)">
                <span class="question-text">
                  <span class="Q">Q</span>
                  <span class="text">{{ t('返金は可能でしょうか？') }}</span>
                </span>
                <span class="toggle-icon">{{ isOpen.cancel[2] ? '−' : '+' }}</span>
              </span>
              <transition name="fade">
                <div v-if="isOpen.cancel[2]" class="answer">
                  <div class="answer-text">
                    <span class="A">A</span>
                    <div class="answer-text-content">

                      <div class="text">{{ t('返金は原則不可となります。') }}</div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'FAQ',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  data() {
    return {
      isOpen: {
        site: [true, true, false, false, false, false, false],
        shipping: [true, false, false, false, false],
        product: [true, false],
        gacha: [true],
        Xmarket: [true, false],
        account: [true, false, false, false],
        selling: [true, false, false, false],
        coin: [true, false],
        cancel: [true, false, false],
      },
    };
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      currentLanguage: 'user/currentLanguage',
    }),
    referralBonusLink() {
      return this.currentLanguage === 'ja'
        ? 'https://gtchax0218.zendesk.com/hc/ja/articles/4704693600414-%E5%8F%8B%E9%81%94%E7%B4%B9%E4%BB%8B%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6'
        : 'https://gtchax0218.zendesk.com/hc/en-us/articles/4704693600414-About-introducing-friends';
    },
    rankBonusLink() {
      return this.currentLanguage === 'ja'
        ? 'https://gtchax0218.zendesk.com/hc/ja/articles/4679247601310-%E4%BC%9A%E5%93%A1%E3%83%A9%E3%83%B3%E3%82%AF%E5%88%B6%E5%BA%A6%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6'
        : 'https://gtchax0218.zendesk.com/hc/en-us/articles/4679247601310-About-Rank-Bonuses';
    },
    xmarketLink() {
      return this.currentLanguage === 'ja'
        ? 'https://gtchax0218.zendesk.com/hc/ja/articles/4679257464862-Xmarket%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6'
        : 'https://gtchax0218.zendesk.com/hc/en-us/articles/4679257464862-About-Xmarket';
    },
    addressChangeLink() {
      return this.currentLanguage === 'ja'
        ? 'https://form.run/@address'
        : 'https://wa.me/818028271055';
    },
    notesLink() {
      return this.currentLanguage === 'ja'
        ? 'https://gtchax0218.zendesk.com/hc/ja/articles/4704597224350-%E6%B3%A8%E6%84%8F%E4%BA%8B%E9%A0%85'
        : 'https://gtchax0218.zendesk.com/hc/en-us/articles/4704597224350-Notes';
    },
    contactLink() {
      return this.currentLanguage === 'ja'
        ? 'https://form.run/@gtchaxonline-contact'
        : 'https://wa.me/818028271055';
    },
    withdrawalLink() {
      return this.currentLanguage === 'ja'
        ? 'https://form.run/@gtchaxonline-withdrawal'
        : 'https://wa.me/818028271055';
    },
  },
  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
  methods: {
    toggleQuestion(title, index) {
      // すべての質問を閉じる
      this.isOpen[title] = this.isOpen[title].map(() => false);
      // 選択した質問だけ開く
      this.$set(this.isOpen[title], index, true);
    },
  },
};
</script>

<style lang="scss" scoped>
.faq{
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .block {
          margin-bottom: 10px;
          .question {
            color: #019a95;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px;
            border: 1px solid #ccc;
            transition: background-color 0.3s;
            &:hover {
              background-color: #e0e0e0;
            }
            &.active {
              background-color: #f0f0f0;
            }
          }
          .Q{
            color: #019a95;
            font-size: 18px;
            font-weight: bold;
            margin-right: 10px;
            padding: 0 10px;
            border-right: 1px solid gray;
          }
          .toggle-icon {
            color: gray;
            font-size: 18px;
            font-weight: bold;
          }
          .answer {
            padding: 10px;
            background-color: #fff;
            border: 1px solid #ccc;
            border-top: none;
            .answer-text{
              display: flex;
              .A{
                color: #000000;
                font-size: 18px;
                font-weight: bold;
                margin-right: 10px;
                padding: 0 10px;
                border-right: 1px solid gray;
              }
              .text{
                display: block;
              }
              .text.pre-line{
                white-space: pre-line;
              }
              .url{
                .text{
                  color: black;
                  text-decoration: underline;
                }
                &:hover .text{
                  color: gray;
                }
              }
            }
          }
          & + .shadow-box-title-description {
            margin-top: 40px;
          }
        }
      }
    }
  }
}
.fade-enter-active, .fade-leave-active {
  transition: max-height 0.4s ease-in-out, opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  overflow: hidden;
}

.fade-enter, .fade-leave-to {
  max-height: 0;
  opacity: 0;
  transform: scaleY(0);
  transform-origin: top;
}

.fade-enter-to, .fade-leave {
  max-height: 500px; /* 必要に応じて調整 */
  opacity: 1;
  transform: scaleY(1);
}

</style>
